import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/aseb.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/blockade.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/board_path.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/board_starting_tiles.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/board.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/capture_protected.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/capture.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/masters-senet-boards.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/safe_tiles.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/special_tiles.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/tile_i.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/tile_iv_to_ankh.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/tile_v.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/tiles_123.png");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/MTG-banner.png");
